import appData from "../_data/appData.json";
import { filterByKey, filterByItemKey } from "../lib/filters";
import { EXISTS, NOTEXISTS } from "../lib/constants";
import { searchBooks, searchSeries } from "../lib/search";

import { isNotNullOrEmpty } from "../lib/utilities";

export const getVisibleBooks = () => {
  return filterByKey("hidden", NOTEXISTS, appData.books);
};

export const getNextUpcomingBook = () => {
  const today = new Date();
  const books = getVisibleBooks().filter((x) => new Date(x.pubDate) > today);

  if (isNotNullOrEmpty(books)) {
    // Soonest release first, unlike sortByPubDate's newest-first ordering.
    return books.sort((a, b) => new Date(a.pubDate) - new Date(b.pubDate))[0];
  }

  return [];
};

export const getLatestBook = () => {
  const today = new Date();
  const books = getVisibleBooks().filter((x) => new Date(x.pubDate) <= today);
  return sortByPubDate(books)[0];
};

export const searchItems = (search, items) => {
  if (!search || !items) return [];
  return searchBooks(search, items);
};

export const getAllSeries = () => {
  return appData.series;
};

export const searchSeriesItems = (search, seriesList) => {
  if (!search || !seriesList) return [];
  return searchSeries(search, seriesList);
};

export const getBooksById = (id) => {
  return filterByKey("id", id, appData.books);
};

export const getBooksByGenre = (genre, items) => {
  return filterByItemKey("genres", genre, items ?? appData.books);
};

export const getBooksByCategory = (category, items) => {
  return filterByItemKey("categories", category, items ?? appData.books);
};

export const getBooksBySeries = (seriesId, items) => {
  return filterByItemKey("series", seriesId, items ?? appData.books);
};

export const getCategoriesByGenre = (genre) => {
  return filterByItemKey("genres", genre, appData.categories);
};

export const getSeriesById = (seriesId) => {
  return filterByKey("id", seriesId, appData.series);
};

export const getSeriesByGenre = (genre) => {
  return filterByItemKey("genres", genre, appData.series);
};

export const getBookItemsBySeriesId = (seriesId) => {
  const visibleBooks = getVisibleBooks();
  return filterByItemKey("series", seriesId, visibleBooks);
};

export const getFeaturedBooks = (items) => {
  return filterByItemKey("categories", "featured", items);
};

export const getTrailers = (items) => {
  return filterByKey("trailerUrl", EXISTS, items);
};

export const sortByPubDate = (items) => {
  return items.sort((a, b) => new Date(b.pubDate) - new Date(a.pubDate));
};

export const sortBySeriesOrder = (items) => {
  return items.sort((a, b) => a.seriesNum - b.seriesNum);
};
